import { type CaseReducer, type PayloadAction } from '@reduxjs/toolkit';

import { type FilterGroupState, type SaleAndPurchaseFilters } from '../types';

const updateSalesAndPurchaseFiltersCase: CaseReducer<
  FilterGroupState,
  PayloadAction<Partial<SaleAndPurchaseFilters>>
> = (state, action) => {
  state.salesAndPurchases = {
    ...state.salesAndPurchases,
    ...action.payload,
  };

  return state;
};

export { updateSalesAndPurchaseFiltersCase };
